import styled from "styled-components";
import { Button } from "@mui/material";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0.4rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		width: 100%;
	}
	/* Notation: Mobile in landscape mode  */
	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-height: 500px) {
		width: 100%;
	}
`;

interface IButtonTranslateProps {
	$active?: boolean;
}

export const ButtonTranslate = styled(Button)<IButtonTranslateProps>`
	&&& {
		height: 32px;
		width: 40px;
		min-width: 40px;
		border: 1px solid ${({ $active }) => ($active ? "#3f5ec9" : "#949494")};
		border-radius: 8px;

		font-size: 0.8rem;
		color: ${({ $active }) => ($active ? "#3f5ec9" : "#949494")};
		font-weight: bold;
		text-align: center;

		&:hover {
			filter: brightness(1.1);
		}
		@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
			width: 100%;
			min-width: 100%;
		}

		/* Notation: Mobile in landscape mode  */
		@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-height: 500px) {
			width: 100%;
			min-width: 100%;
		}
	}
`;
